import type { FaireProductEntity } from "../../entity_types/product";

export const p_8j8des9wj6: FaireProductEntity = {
  token: "p_8j8des9wj6",
  type: "product",
  name: "Cacao Nibs",
  brandToken: "b_djuc44eyt2",
  brandName: "Ora Cacao",
  imageUrl:
    "https://cdn.faire.com/fastly/922a03982c129dd3bd70d586c32940fa846d07f0deb5be12eb04a08b9e4bac41.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/38c26df3f04be726cfe2d551cc157211372181a474ff04f104fa5e9d86ee7633.png",
    "https://cdn.faire.com/fastly/9a706e5004f31c5999085c48b42d099fc73e76e1c26f0fbc82d9fcbf2d99117c.png",
    "https://cdn.faire.com/fastly/250b05b69509308336fecf989a782c20ca1060754b0f216330c6f8a100e74858.png",
    "https://cdn.faire.com/fastly/e8062cbb6dcc5dc04f744a586c2d07e3e4f4618d9a483ace728aa21fc5ffa8f2.png",
  ],
  priceDollars: 6,
  description:
    "We source the highest quality fermented cacao beans from regenerative family farms (not monoculture cacao plantations), lightly roast them in micro batches (it’s an obsessive art form), and shell and crack them into small pieces (voila! cacao nibs). This careful sourcing and minimal processing gives our nibs a rich, nutty flavor…and has social impact.\n\nOur organic cacao is grown in a regenerative agroforestry project in the Rwenzori Mountains of Uganda, part of the headwaters of the Nile River. 50% of the small-holder farmers are women and 70% are under 35, so with these cacao nibs, you’re supporting the next generation of farmers and protecting a diverse ecosystem.\n\nDisclaimer... it is very hard to make any form of drinking chocolate from these without professional equipment because they will not melt with heat. If you are interested in drinking chocolate, best to buy our ceremonial cacao.",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T01:35:44.003Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
